export type UiTheme = 'light' | 'dark' | 'contrast';

export const UI_THEME_STORAGE_KEY = 'crm-ui-theme';

export const UI_THEME_OPTIONS: Array<{ value: UiTheme; label: string }> = [
  { value: 'light', label: 'Світла' },
  { value: 'dark', label: 'Темна' },
  { value: 'contrast', label: 'Контрастна' },
];

export const isUiTheme = (value: string): value is UiTheme =>
  value === 'light' || value === 'dark' || value === 'contrast';

export const applyUiTheme = (theme: UiTheme) => {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(UI_THEME_STORAGE_KEY, theme);
};
